module.exports = __webpack_public_path__ + "img/madnessBanner_320.44823dbd.png";